import { render, staticRenderFns } from "./MostAppreciatedItem.vue?vue&type=template&id=90f2ce56&scoped=true"
import script from "./MostAppreciatedItem.vue?vue&type=script&lang=ts"
export * from "./MostAppreciatedItem.vue?vue&type=script&lang=ts"
import style0 from "./MostAppreciatedItem.vue?vue&type=style&index=0&id=90f2ce56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f2ce56",
  null
  
)

export default component.exports